<!-- eslint-disable max-len -->
<template>
  <v-main>
    <v-row no-gutters>
      <v-dialog
        v-model="inviteDialog"
        max-width="600"
      >
        <v-card light>
          <v-card-title class="text-h4">Prospect Invite</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="dialogStatus === 200">
                <div class="text-body-1">The user you are inviting already exists.</div>
                <div class="text-body-1 pt-3">You may want to add a new company to this user by going to the <b>Prospect Status</b> page and clicking on the <v-icon>mdi-home-plus-outline</v-icon> icon.</div>
              </v-col>
              <v-col cols="12" v-if="dialogStatus === 204">User created successfully</v-col>
              <v-col cols="12" v-if="dialogStatus !== 204 && dialogStatus !== 200">{{ dialogStatus }}</v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="inviteDialog = false"
              color="primary"
            >Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col cols="12">
        <v-sheet
          color="sheet"
          height="150"
        >
          <!--  -->
        </v-sheet>
      </v-col>
      <v-container :class="$vuetify.breakpoint.name == 'lg' ? 'px-16' : ''">
        <v-row no-gutters>
          <v-col
            cols="12"
            style="margin-top: -150px"
          >
            <v-card
              flat
              style="background-color: transparent !important;"
              max-width="700px"
            >
              <v-card-title class="text-h4">Invite Prospects</v-card-title>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -48px; position: relative;"
          >
            <v-form ref="form">
              <v-card
                flat
                outlined
                rounded="lg"
                max-width="700px"
              >
                <v-row class="mt-5 mx-5">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="FirstName"
                      outlined
                      label="First Name"
                      class="rounded-lg"
                      hide-details
                      :rules="[rules.required]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="LastName"
                      outlined
                      label="Last Name"
                      class="rounded-lg"
                      hide-details
                      :rules="[rules.required]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    v-for="(item, index) in Company"
                    :key="index"
                  >
                    <v-text-field
                      ref="company"
                      v-model="Company[index]"
                      :key="index"
                      outlined
                      label="Company"
                      class="rounded-lg"
                      hide-details
                      :append-outer-icon="Company.length - 1 === index ? 'mdi-plus' : 'mdi-minus'"
                      :rules="[rules.required]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                      @click:append-outer="Company.length - 1 === index ? addNewCompany() : removeCompany(index)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="Title"
                      outlined
                      label="Position"
                      class="rounded-lg"
                      hide-details
                      :rules="[rules.required]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      ref="email"
                      v-model="Email"
                      outlined
                      label="Email"
                      class="rounded-lg"
                      :hide-details="hideEmailValidationText"
                      :rules="[rules.required, rules.email]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="Message"
                      outlined
                      label="Message"
                      class="rounded-lg"
                      hide-details
                      :rules="[rules.required]"
                      validate-on-blur
                      @blur="() => $refs.form.resetValidation()"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      block
                      class="mb-6 rounded-lg"
                      color="primary"
                      @click="sendProspectInvite"
                      :loading="loading"
                    >Send Invite</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-form>
          </v-col>

        </v-row>
      </v-container>
    </v-row>
  </v-main>
</template>

<script>
import toWords from '@/Data/NumToWords';

export default {
  name: 'InviteProspect',
  data: () => ({
    btnInviteIndex: -1,
    btnInviteLoading: false,
    btnInviteIconSend: 'mdi-send',
    btnInviteIconSuccess: 'mdi-check',
    FirstName: null,
    LastName: null,
    Company: [
      '',
    ],
    Title: null,
    Email: null,
    hideEmailValidationText: true,
    Message: 'Thank you for the opportunity to earn your business, we look forward to working with you!',
    rules: {
      required: (value) => !!value || 'Required',
      // eslint-disable-next-line max-len
      email: (value) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Email is invalid',
    },
  }),
  computed: {
    inviteDialog: {
      get() {
        return this.$store.state.prospectUserInvitationErrorDialog;
      },
      set(value) {
        this.$store.commit('updateProspectUserInvitationErrorDialog', value);
      },
    },
    prospects() {
      return this.$store.state.prospects;
    },
    dialogStatus: {
      get() {
        return this.$store.state.prospectUserInvitationErrorResponse;
      },
      set(value) {
        this.$store.commit('updateProspectUserInvitationErrorResponse', value);
      },
    },
    loading: {
      get() {
        return this.$store.state.btnInviteProspectLoading;
      },
      set(value) {
        this.$store.commit('updateBtnInviteProspectLoading', value);
      },
    },
    resendInviteBtn() {
      return this.$store.state.btnInviteResendLoading;
    },
  },
  methods: {
    sendProspectInvite() {
      if (this.$refs.form.validate()) {
        this.$store.commit('updateProspectUserInvitation', {
          FirstName: this.FirstName,
          LastName: this.LastName,
          Company: this.Company,
          Title: this.Title,
          Email: this.Email,
          Message: this.Message,
        });
        this.loading = true;
        this.$store.dispatch('inviteProspectUser');
      } else if (!this.$refs.email.valid) {
        this.hideEmailValidationText = false;
      } else {
        this.hideEmailValidationText = true;
      }
    },
    resendInvite(email) {
      this.btnInviteLoading = true;
      this.$store.commit('UpdateBtnInviteResendLoading', true);
      this.$store.dispatch('resendInvite', email).then(() => {
        this.btnInviteLoading = false;
        this.dialogText.existingEmails.addresses[this.btnInviteIndex].icon = 'mdi-check';
      });
    },
    addNewCompany() {
      const index = this.Company.length;
      if (this.Company[0]) {
        // this.hideEmailValidationText = true;
        const company = this.Company[0];

        let word = toWords(index + 1);
        let nextIndex = index + 1;

        // eslint-disable-next-line no-plusplus, no-loop-func
        while (this.Company.findIndex((x) => x.includes(toWords(nextIndex))) >= 0 && nextIndex++) {
          word = toWords(nextIndex);
        }

        this.Company.push(`${company}${word}`);
      }
    },
    removeCompany(index) {
      this.Company.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
